module.exports = __webpack_public_path__ + "ticket.cc00d056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/ticket.png
// module id = 1744
// module chunks = 0